
<div class="scrollable-container">
  @if (showSpinner) {
    <div class="loading">
      <fa-icon [icon]="faCircleNotch" [animation]="'spin'"></fa-icon>
    </div>
  }
  @if (events.length > 0) {
    @for (event of events; track event) {
      <div class="row ms-3 mb-5 me-3">
        <div class="col-3">
          <!-- Start Time -->
          {{event.startTime}}
        </div>
        <div class="col-9">
          <div class="row">
            <!-- Name -->
            {{event.name}}
          </div>
          <div class="row">
            <!-- Location -->
            <small><em>{{event.location}}</em></small>
          </div>
        </div>
      </div>
    }
  }
  @if (!showSpinner && events.length == 0) {
    <div class="no-today-event-container">
      <div class="notice-box">
        NO UPCOMING HEARINGS
        <br />
        ARE SCHEDULED
      </div>
    </div>
  }
</div>
